// Free tote gift reconciler. reconcileGift is pure (CommonJS export for node --test);
// the browser half listens to cart:updated and applies the returned action.
(function (root) {
  function isGift(line) { return !!(line.properties && line.properties._rooted_gift === 'true'); }
  function packOf(line, optionName) {
    var o = (line.options_with_values || []).find(function (x) { return x.name === optionName; });
    return o ? String(o.value).trim() : null;
  }
  function reconcileGift(cart, cfg) {
    if (!cfg || !cfg.giftVariantId) return { action: 'none' };
    var items = (cart && cart.items) || [];
    var gifts = items.filter(isGift);
    var qualifies = items.some(function (l) {
      return !isGift(l) && cfg.qualifying.indexOf(packOf(l, cfg.optionName)) !== -1;
    });
    if (qualifies && gifts.length === 0) {
      return { action: 'add', id: cfg.giftVariantId, quantity: 1, properties: { _rooted_gift: 'true' } };
    }
    if (!qualifies && gifts.length > 0) return { action: 'remove', key: gifts[0].key };
    if (gifts.length > 1) return { action: 'remove', key: gifts[1].key };
    if (qualifies && gifts[0].quantity !== 1) return { action: 'set', key: gifts[0].key, quantity: 1 };
    return { action: 'none' };
  }
  var api = { reconcileGift: reconcileGift };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  root.RootedGift = api;

  var busy = false;
  // Paused while a multi-step cart change (the <rooted-upgrade> pack swap) is in
  // flight, so the gift add never races that change. The step that unpauses it
  // emits cart:updated, which reconciles the final cart once.
  var paused = false;
  api.pause = function (value) { paused = !!value; };

  function readConfig() {
    var el = document.getElementById('RootedGiftConfig');
    if (!el) return null;
    try {
      var cfg = JSON.parse(el.textContent);
      cfg.qualifying = (cfg.qualifying || []).map(function (q) { return String(q).trim(); });
      return cfg;
    } catch (err) { return null; }
  }

  // Applies one action. After a successful mutation the cart is checked again so
  // multi-step fixes (for example two duplicate gift lines) converge. A failed
  // mutation stops the chain, so an unavailable gift variant cannot loop.
  function run(cart, depth) {
    var store = root.MasterTheme && root.MasterTheme.cart;
    var cfg = readConfig();
    if (busy || paused || !store || !cfg || !cart) return;
    var act = reconcileGift(cart, cfg);
    if (act.action === 'none') return;
    busy = true;
    var p;
    if (act.action === 'add') {
      // CartStore.add takes an array of items plus { openDrawer }
      p = store.add([{ id: act.id, quantity: 1, properties: act.properties }], { openDrawer: false });
    } else {
      // CartStore.update posts { updates } to /cart/update.js, keyed by line key
      var u = {}; u[act.key] = act.action === 'remove' ? 0 : act.quantity;
      p = store.update(u);
    }
    Promise.resolve(p).then(function () {
      busy = false;
      if (depth < 5) run(store.state, depth + 1);
    }, function () { busy = false; });
  }

  // cart:updated also fires with action 'init' at boot (theme.js), so a cart that
  // already holds a qualifying pack is reconciled on page load.
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart) run(e.detail.cart, 0);
  });
})(this);
